import React, { useContext, useState, useEffect } from "react";
import { StateContext } from "../../contexts/StateContext";
import { Image, Button, Modal, Table, Row } from "react-bootstrap";
import { Check2 } from "react-bootstrap-icons";
import GlutenFree from "../../assets/images/gluten_free3.png";
import _ from "lodash";

const AddIngredients = ({ selectedDough, clearDough }) => {
  const { ingredients, cart, setCart } = useContext(StateContext);
  const [selectedIngredients, setSelectedIngredients] = useState(null);

  useEffect(() => {
    if (!selectedIngredients) {
      let newIngredients = [];
      ingredients.ingredients.map((item) =>
        newIngredients.push({ ...item, selected: false })
      );
      setSelectedIngredients(newIngredients);
    }
  }, [selectedIngredients, ingredients.ingredients]);

  const selectHandler = (item) => {
    let newSelectedIngredients = [...selectedIngredients];
    const index = _.findIndex(newSelectedIngredients, item);
    newSelectedIngredients[index].selected =
      !newSelectedIngredients[index].selected;
    setSelectedIngredients(newSelectedIngredients);
  };

  const addToCart = () => {
    const onlySelectedIngredients = selectedIngredients.filter(
      (item) => item.selected === true
    );
    const newCartItem = {
      dough: selectedDough,
      ingredients: onlySelectedIngredients,
      count: 1,
    };
    const newCart = _.cloneDeep(cart);
    newCart.items.push(newCartItem);
    setCart(newCart);
    clearDough();
  };

  return (
    <Modal
      show
      onHide={clearDough}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Row className="m-0">
        <h4 className="align-middle mt-2 text-success">Ingredients</h4>
        <hr className="border border-dark" />
      </Row>
      <Table striped bordered hover>
        <tbody>
          {selectedIngredients &&
            selectedIngredients.map((item) => {
              return (
                <tr key={item._id} onClick={() => selectHandler(item)}>
                  <td>
                    {item.gluten_free && (
                      <Image src={GlutenFree} style={{ height: "30px" }} />
                    )}
                  </td>
                  <td>{item.selected && <Check2 />}</td>
                  <td>{item.name}</td>
                  <td>{item.price} €</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      <hr className="border border-dark m-0" />
      <Button
        variant="outline-success"
        className="ms-auto me-3"
        onClick={addToCart}
      >
        + ADD TO CART
      </Button>
    </Modal>
  );
};

export default AddIngredients;
